<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created() {},
  mounted() {
  },
  beforeCreate() {
  },
  methods: {
  },
};
</script>
<style lang="less">
</style>
